module.exports = __webpack_public_path__ + "static/media/loc1_img22.bfdcf411.jpg";